import { render, staticRenderFns } from "./HatirlatPicker.vue?vue&type=template&id=66768b9a"
import script from "./HatirlatPicker.vue?vue&type=script&lang=ts"
export * from "./HatirlatPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports